<template>
  <section class="technical-support-section" aria-labelledby="technical-support-title">
    <div class="technical-support-inner">

      <h2 id="technical-support-title" class="section-title">Affiancamento tecnico</h2>

      <!-- Parte 1: immagine + paragrafi -->
      <div class="part-1">
        <div class="part-1-image-wrapper">
          <img
            class="part-1-image"
            src="/images/close-up-football-team-players.webp"
            alt=""
            aria-hidden="true"
          />
        </div>
        <div class="part-1-text">
          <p class="paragraph">Per noi, affiancamento tecnico significa molto più che proporre allenamenti. Significa entrare nella realtà di una società sportiva, comprenderne identità, bisogni, risorse e obiettivi, per costruire insieme un percorso di crescita concreto e sostenibile. Ogni contesto è diverso e richiede ascolto, osservazione e confronto. Per questo il nostro lavoro parte dall’analisi della situazione esistente, prosegue nella definizione di una direzione condivisa con lo staff tecnico e si traduce in una programmazione chiara, coerente e applicabile ogni giorno.</p>
          <p class="paragraph">L’affiancamento tecnico è un processo dinamico: dalla visione a lungo termine alla gestione del lavoro quotidiano, fino al monitoraggio e al testing: strumenti fondamentali per verificare il percorso e adattarlo quando necessario. Affiancare una società, per noi, significa portare metodo, competenza e visione, aiutandola a crescere in modo strutturato, consapevole e duraturo perché ogni realtà ha un potenziale spesso più grande di quanto riesca a esprimere da sola.</p>
        </div>
      </div>

      <!-- Parte 2: box full-width con bordo bianco -->
      <div class="part-2">
        <p class="part-2-text">Non lavoriamo solo per migliorare l’allenamento. Lavoriamo per dare a ogni società una direzione, un metodo e una prospettiva di crescita reale.</p>
      </div>

      <!-- Bottone-pill -->
      <div class="pill-wrapper">
        <a href="#consulenza" class="section-pill" @click.prevent="scrollToCTA">Richiedi un confronto<span aria-hidden="true">→</span></a>
      </div>

    </div>
  </section>
</template>

<script setup>
function scrollToCTA() {
  const target = document.getElementById('consulenza')
  if (!target) return
  const header = document.querySelector('.site-header')
  const top = target.getBoundingClientRect().top + window.scrollY - (header ? header.offsetHeight : 0)
  window.scrollTo({ top, behavior: 'smooth' })
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/colors.scss";

.technical-support-section {
  background-color: $secondary-warm;
  color: $white;
  width: 100%;
}

.technical-support-inner {
  max-width: 1440px;
  margin: 0 auto;
  padding: 56px 24px;
  display: flex;
  flex-direction: column;
  gap: 48px;
}

.section-title {
  margin: 0;
  font-size: 2rem;
  font-weight: 700;
  line-height: 1.2;
}

/* ── Parte 1 ── */

.part-1 {
  display: flex;
  flex-direction: column;
  gap: 32px;
}

.part-1-image-wrapper {
  width: 100%;
  aspect-ratio: 4 / 3;
  overflow: hidden;
  border-radius: 25px;
}

.part-1-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  display: block;
}

.part-1-text {
  display: flex;
  flex-direction: column;
  gap: 32px;
}

.paragraph {
  margin: 0;
  font-size: 1.125rem;
  line-height: 1.7;
}

/* ── Parte 2 ── */

.part-2 {
  border: 1px solid $white;
  border-radius: 25px;
  padding: 32px 24px;
}

.part-2-text {
  margin: 0;
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1.7;
  text-align: left;
}

/* ── Pill ── */

.pill-wrapper {
  display: flex;
  justify-content: center;
}

.section-pill {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: $secondary-warm;
  color: $white;
  font-size: 1rem;
  font-weight: 700;
  border-radius: 39px;
  border: 1px solid $white;
  padding: 10px 32px;
  text-decoration: none;
  white-space: nowrap;
}

.section-pill:hover {
  background-color: $secondary-warm-soft;
  color: $black;
}

.section-pill:focus-visible {
  outline: 2px solid $white;
  outline-offset: 3px;
}

/* ── Tablet & Desktop ── */

@media (min-width: 768px) {
  .technical-support-inner {
    padding: 64px 40px;
  }

  .part-1 {
    flex-direction: row;
    gap: 48px;
    align-items: stretch;
  }

  .part-1-image-wrapper {
    flex: 1;
    height: auto;
  }

  .part-1-text {
    flex: 1;
    justify-content: center;
  }
}

@media (min-width: 1440px) {
  .technical-support-inner {
    padding: 80px 120px;
  }

  .section-title {
    font-size: 2.4rem;
  }

  .part-2 {
    padding: 40px 48px;
  }
}
</style>
